import { useState } from "react";
import loader from "../../../../../components/recharts/loader.gif";
import SimulationCumulatedVolumeAnalysis from "./TableBuySell/SimulationCumulatedVolume";
import SimulationCumulatedCostAnalysis from "./TableBuySell/SimulationCumulatedCost";
import BuySellAnalysis from "./BuySellChart/BuySell";

interface DeficitSlot {
  slot: string;
  timeRange: string;
  deficitMW: number;
}

interface SurplusSlot {
  slot: string;
  timeRange: string;
  surplusMW: number;
}

export default function SurplusDeficitAnalysis({
  selectedBlock,
  refreshKey,
  setError,
  setUniqueTargetDate,
  activeTab,
  selectedExchanges,
  selectedMarkets,
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  setUniqueTargetDate?: any;
  activeTab: string;
  selectedExchanges?: string[];
  selectedMarkets?: string[];
}) {
  const [loading, setLoading] = useState(false);
  // Shared state for Buy/Sell or Buy/Sell Delta toggle - syncs chart and table
  const [activeChartTab, setActiveChartTab] = useState<string>("Buy/Sell");

  // Shared Data for Buy/Sell Volume (Chart -> Table sync)
  const [sharedVolumeData, setSharedVolumeData] = useState<any>(null);
  const [sharedVolumeView, setSharedVolumeView] = useState<"buyers" | "sellers">("buyers");

  // Shared Data for Buy/Sell Delta (Chart -> Table sync)
  const [sharedDeltaData, setSharedDeltaData] = useState<any>(null);
  const [sharedDeltaView, setSharedDeltaView] = useState<"drawal" | "injection">("drawal");

  return (
    <div className="w-full h-full flex flex-col lg:flex-row gap-2 min-w-0 font-inter">
      {/* System Balance Chart - 70% width on large screens */}
      <div className="h-full min-w-0 w-full lg:w-[69%] flex-shrink-0">
        {loading ? (
          <div className="w-full h-full bg-white flex items-center justify-center rounded-2xl border border-[#E5E7EB]">
            <img src={loader} width={200} alt="loader" className="block" />
          </div>
        ) : (
          <div className="w-full h-full overflow-auto">
            <BuySellAnalysis
              selectedBlock={selectedBlock}
              refreshKey={refreshKey}
              setError={setError}
              setUniqueTargetDate={setUniqueTargetDate}
              selectedExchanges={selectedExchanges}
              selectedMarkets={selectedMarkets}
              activeChartTab={activeChartTab}
              setActiveChartTab={setActiveChartTab}
              setSharedData={setSharedVolumeData}
              setSharedView={setSharedVolumeView}
              setSharedDeltaData={setSharedDeltaData}
              setSharedDeltaView={setSharedDeltaView}
            />
          </div>
        )}
      </div>

      {/* Table Section - 30% width on large screens */}
      <div className="h-full min-w-0 overflow-auto w-full lg:w-[30%] flex-shrink-0">
        {loading ? (
          <div className="w-full h-full bg-white flex items-center justify-center rounded-2xl border border-[#E5E7EB]">
            <img src={loader} width={200} alt="loader" className="block" />
          </div>
        ) : (
          <div className="w-full h-full min-w-0 overflow-hidden">
            {activeTab === "Volume" && (
              <SimulationCumulatedVolumeAnalysis
                selectedBlock={selectedBlock}
                refreshKey={refreshKey}
                setError={setError}
                setUniqueTargetDate={setUniqueTargetDate}
                activeChartTab={activeChartTab}
                // Pass shared data down to table
                sharedData={sharedVolumeData}
                sharedView={sharedVolumeView}
                sharedDeltaData={sharedDeltaData}
                sharedDeltaView={sharedDeltaView}
                selectedExchanges={selectedExchanges}
                selectedMarkets={selectedMarkets}
              />
            )}
            {activeTab === "Cost" && (
              <SimulationCumulatedCostAnalysis
                selectedBlock={selectedBlock}
                refreshKey={refreshKey}
                setError={setError}
                setUniqueTargetDate={setUniqueTargetDate}
                activeChartTab={activeChartTab}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
